// https://docs.google.com/spreadsheets/d/1FP3UCK-g7Y_4zskVGiq1PiURuieZ3jlRbQKL6uGHGKg/edit?gid=0#gid=0
const domains = [
  "gmail.com",
  "web.de",
  "gmx.de",
  "icloud.com",
  "hotmail.de",
  "hotmail.com",
  "yahoo.de",
  "outlook.de",
  "googlemail.com",
  "t-online.de",
  "gmx.net",
  "yahoo.com",
  "outlook.com",
  "live.de",
  "freenet.de",
  "aol.com",
  "gmx.at",
  "true-skin.de",
  "online.de",
  "me.com",
  "mail.de",
  "gmx.ch",
  "posteo.de",
  "aol.de",
  "arcor.de",
  "bluewin.ch",
  "ymail.com",
  "mail.ru",
  "hotmail.ch",
  "mein.gmx",
  "msn.com",
  "live.com",
  "kabelmail.de",
  "rocketmail.com",
  "yahoo.com.br",
  "gmail.de",
  "protonmail.com",
  "magenta.de",
  "mailbox.org",
  "gamil.com",
  "privaterelay.appleid.com",
  "gmx.com",
  "ewetel.net",
  "email.de",
  "unitybox.de",
  "icloud.de",
  "live.at",
  "yahoo.fr",
  "proton.me",
  "wp.pl",
  "ewe.net",
  "mailinator.com",
  "onlinehome.de",
  "hotmail.fr",
  "vodafone.de",
  "windowslive.com",
  "mail.com",
  "sunrise.ch",
  "web.dd",
  "hispeed.ch",
  "fn.de",
  "mac.com",
  "myyahoo.com",
  "abv.bg",
  "netcologne.de",
  "wen.de",
  "hmail.com",
  "bk.ru",
  "googlemail.con",
  "hotmail.it",
  "aon.at",
  "htp-tel.de",
  "osnanet.de",
  "outlook.at",
  "my.com",
  "pm.me",
  "yandex.ru",
  "iu-study.org",
  "rwth-aachen.de",
  "ok.de",
  "o2.pl",
  "hotmail.co.uk",
  "whu.edu",
  "yahoo.it",
  "yahoo.co.uk",
  "paralect.com",
  "ish.de",
  "rub.de",
  "unity-mail.de",
  "tu-dortmund.de",
  "aim.com",
  "kabelbw.de",
  "berlin.de",
  "chello.at",
  "o2mail.de",
  "uni-bielefeld.de",
  "posteo.net",
  "o2online.de",
  "yandex.com",
  "live.fr",
]

export default domains
